import { useAppScopeStore } from '@frontend/scope';
import { useMemoizedArray } from '../use-memoized-array';

export type LocationSelectionType = keyof Pick<
  ReturnType<typeof useAppScopeStore>,
  'accessibleLocationIds' | 'selectedLocationIds'
>;

export type MerchantLocationSelectionType =
  | LocationSelectionType
  | (string & NonNullable<unknown>) //hack for auto completion of the above two types
  | (string | undefined)[]
  | undefined;

/**
 * Hook to get location IDs based on the selection type.
 * @param locationId - The type of location selection ('accessibleLocationIds', 'selectedLocationIds', a locationId string or an array of location IDs).
 */
export const useMerchantLocationIds = (locationSelectionType: MerchantLocationSelectionType) => {
  const appScopeStore = useAppScopeStore();

  let locationIds = locationSelectionType;
  if (locationSelectionType === 'selectedLocationIds' || locationSelectionType === 'accessibleLocationIds') {
    locationIds = appScopeStore[locationSelectionType as LocationSelectionType];
  }
  return useMemoizedArray(locationIds) satisfies string[] as string[];
};
